import { Component, OnInit, Input } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { FormResponse } from 'src/models/form-response';

@Component({
  selector: 'app-form-errors',
  templateUrl: './form-errors.component.html',
  styleUrls: ['./form-errors.component.scss']
})
export class FormErrorsComponent implements OnInit {

  @Input() formElementName: string;
  @Input() formElementControl: AbstractControl;
  @Input() formResponse: FormResponse;

  public errorMessages = new Map(
    [
      ['errors.required', 'Dieses Feld muss ausgefüllt sein.'],
      ['errors.email', 'Die Email-Adresse ist ungültig.'],
      ['errors.isMatching', 'Die Passwörter stimmen nicht überein.'],
      ['errors.pattern', 'Das Passwort muss aus Groß- und Kleinbuchstaben, sowie mindestens einer Zahl und einem Sonderzeichen bestehen. Zudem muss es mindestens 8 Zeichen lang sein.'] // used by password
    ]
  );

  constructor() { }

  ngOnInit(): void {
  }

  public getFormValidationErrors(): Array<string> {
    const messages = new Array();

    const controlErrors: ValidationErrors = this.formElementControl.errors;
    if (controlErrors != null) {
      Object.keys(controlErrors).forEach(keyError => {
        messages.push(this.errorMessages.get('errors.' + keyError));
      });
    }

    return messages;
  }

}
